export default __webpack_public_path__ + "static/media/exito-time.2c642277.gif";